import { render, staticRenderFns } from "./UserAddEditModal.vue?vue&type=template&id=ec52ce8a"
import script from "./UserAddEditModal.vue?vue&type=script&lang=js"
export * from "./UserAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports